<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Edit</span>
        <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>

        <b-form @submit.stop.prevent="edit_item">
          <b-form-group label="Sequence Name:" invalid-feedback="Must be greater then 4 character">
            <b-form-input v-model="item.name" required placeholder="Enter sequence name" :state="validate_state('name')"></b-form-input>
          </b-form-group>

          <b-form-group label="Status:">
            <b-form-select v-model="item.status" :options="['running', 'paused']"></b-form-select>
          </b-form-group>

          <h4>Email Schedule</h4>
          <p>Emails are sent during weekdays between 09:00 and 17:00 in your timezone.</p>
          <!-- <b-badge variant='success' class='mr-1'>Mon</b-badge><b-badge variant='success' class='mr-1'>Tue</b-badge><b-badge variant='success' class='mr-1'>Wed</b-badge><b-badge variant='success' class='mr-1'>Thu</b-badge><b-badge variant='success' class='mr-1'>Fri</b-badge><b-badge variant='dark' class='mr-1'>Sat</b-badge><b-badge variant='dark' class='mr-1'>Sun</b-badge> -->

          <h4>Email Sequence</h4>
          <p>Editing coming soon</p>
          <!-- v-if='all_loaded'  -->
          <!-- <EmailSequence :create="false" :sequence="item"  :profile="profile" :steps="item.steps" :from_email="item.sender ? item.sender.email : ''"  style='max-width: 600px;'/> -->

          <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
        </b-form>

      </div>
    </b-card>
  </b-container>
</template>

<script>
import { db } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
// import EmailSequence from '@/components/EmailSequence'

export default {
  metaInfo: {title: 'Sequence edit'},
  mixins: [ItemMixin],
  // components: {EmailSequence},
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id)
    }
  },
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  data() {
    return {
      collection: 'sequence',
      all_loaded: false
    }
  },
  watch: {
    item: {
      deep: true,
      handler: function() {
        let all_loaded = true
        for (let step of this.item.steps) {
          if (step.body === undefined) {
            all_loaded = false
            break
          }
        }

        this.all_loaded = all_loaded
      }
    }
  }
}
</script>

<style>

</style>
